import React, { useEffect, useRef, useState } from 'react';

const AutoAdjustText = ({ index, editable, text, maxFontSize, minFontSize,onTextChange, property }) => {
    const containerRef = useRef(null);
    const [fontSize, setFontSize] = useState(maxFontSize);
    const [textValue, setTextValue] = useState(text);


    const handleNewTextValue = (e) => {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const { startOffset } = range;

        if (e.target.textContent.length > 0) {
            setTextValue(e.target.textContent);
        } else {
            setFontSize(maxFontSize);
        }

        if (onTextChange && property) {
            onTextChange(e.target.textContent, property, index);
        }


        // Restore cursor position
        requestAnimationFrame(() => {
            if (containerRef.current.firstChild) {
                const newRange = document.createRange();
                newRange.setStart(containerRef.current.firstChild, startOffset);
                newRange.setEnd(containerRef.current.firstChild, startOffset);
                selection.removeAllRanges();
                selection.addRange(newRange);
            }
        });
    }



    useEffect(() => {
        const adjustFontSize = () => {
            if (containerRef.current) {
                const { clientWidth } = containerRef.current;
                const parentWidth = containerRef.current.parentElement.clientWidth;
                if (clientWidth > parentWidth && fontSize > minFontSize) {
                    setFontSize((prevFontSize) => prevFontSize - 1);
                } 
            }
        };
//        console.log('adjust', property, index)

        adjustFontSize();
    }, [textValue, fontSize, maxFontSize, minFontSize]);


    return (
        <span ref={containerRef} contentEditable={editable} inputMode='text' onInput={handleNewTextValue}  dangerouslySetInnerHTML={{ __html: textValue }} style={{ fontSize: `clamp(${minFontSize}px, 2vw, ${maxFontSize}px)`, lineHeight: `clamp(${minFontSize}px, 2vw, ${maxFontSize}px)`}}/>
        
    )
};

export default AutoAdjustText;
